<div class="container" #timelineGraphContainer>
  <div class="header" style="display: flex;">
    <awair-info-popup *ngIf="isInfoPopup" [componentType]="type" #infoPopup></awair-info-popup>
    <object type="image/svg+xml" [attr.data]="sanitizedUrl" style="margin-right: 4px; width: 16px; height: 16px;">Your
      browser does not support SVGs
    </object>
    <span class="header-text" (document:click)="onInfoPopupEvent($event, infoPopupHeader)" #infoPopupHeader>{{type | sensorHeader}}</span>
    <span *ngIf="type !== 'score'" class="header-unit"> ({{type | sensorUnit : (selfOrganizationUser$ | async)?.tempUnit}})</span>
  </div>
  <div class="graph-container" #graphContainer style="position: relative">
    <svg #graph>
      <svg:g #svgGroup>
        <svg:g awair-x-axis #xAxis/>
        <svg:g awair-y-axis #yAxis/>
        <svg:g awair-line-list #lineList/>
        <svg:g awair-dotted-line #dottedLine/>
        <svg:g awair-mouse-event #workArea
               [width]="width"
               [height]="height"
               (hoverEvent)="onHoverTimeline($event)"
               (clickEvent)="onClickTimeline()"
               (outEvent)="onOutTimeline()"/>
        <svg:g awair-big-dot #bigDot
               [temperatureUnit]="(selfOrganizationUser$ | async)?.tempUnit"/>
        <svg:g awair-small-dot #smallDot
               (hoverEvent)="onHoverTriggerEvent($event)"
               (clickEvent)="onClickTriggerEvent($event)"
               (outEvent)="onOutTriggerEvent()"/>
        <svg:g awair-indicator #indicator
               [temperatureUnit]="(selfOrganizationUser$ | async)?.tempUnit"
               (hoverEvent)="onHoverIndicatorDot($event)"
               (clickEvent)="onClickIndicatorDot($event)"
               (outEvent)="onOutIndicatorDot()"/>
        </g>
    </svg>
    <awair-line-tooltip #lineTooltip
                        [lineTooltipInput]="lineTooltipInput"
                        [pinInput]="pinInput"
                        [airNote]="selectedAirNote"
                        [temperatureUnit]="(selfOrganizationUser$ | async)?.tempUnit"
                        [colorScale]="colorThresholdScale">
    </awair-line-tooltip>
    <awair-noti-tooltip #notiTooltip
                        [notiTooltipInput]="notiTooltipInput"
                        [isPinned]="isNotiTooltipPinned"
                        [temperatureUnit]="(selfOrganizationUser$ | async)?.tempUnit">
    </awair-noti-tooltip>
    <awair-global-tooltip #globalTooltip
                          [globalTooltipInput]="globalTooltipInput"
                          [hidden]="!isGlobalTooltipVisible">
    </awair-global-tooltip>
  </div>
</div>
